export enum AppRole {
  ThirsaAdministrator = 1,
  ThirsaCollaborator = 2,
  ClientAdministrator = 3,
  ClientCollaborator = 4,
}

export const AppRoleLabel: Record<AppRole, string> = {
  [AppRole.ThirsaAdministrator]: 'Administrador proveedor',
  [AppRole.ThirsaCollaborator]: 'Usuario proveedor',
  [AppRole.ClientAdministrator]: 'Administrador de cliente',
  [AppRole.ClientCollaborator]: 'Usuario de consulta cliente',
};

export const AppRoleTooltip: Partial<Record<AppRole, string>> = {
  [AppRole.ThirsaAdministrator]: 'Puede realizar cualquier acción.',
  [AppRole.ThirsaCollaborator]: 'Puede realizar cualquier acción a excepción de añadir usuarios.',
  [AppRole.ClientAdministrator]: 'Puede crear y consultar encargos, además de añadir usuarios.',
  [AppRole.ClientCollaborator]: 'Puede crear y consultar encargos.',
};
